module.exports = __webpack_public_path__ + "media/images/emblems/Interlaken-coat_of_arms-005398a20868ff52aba151ff7df372a7.svg";